import { render, staticRenderFns } from "./Cover_setting.vue?vue&type=template&id=12cbd4da&scoped=true&"
import script from "./Cover_setting.vue?vue&type=script&lang=js&"
export * from "./Cover_setting.vue?vue&type=script&lang=js&"
import style0 from "./Cover_setting.vue?vue&type=style&index=0&id=12cbd4da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cbd4da",
  null
  
)

export default component.exports